import React from "react";
import { useAuth } from "../context/AuthContext";

/**
 * Component to conditionally render content based on user permissions
 * Uses AuthContext for real-time permission checking (no localStorage)
 */
const PermissionGuard = ({
  permission = null,
  permissions = null,
  role = null,
  requireAll = false,
  fallback = null,
  children,
}) => {
  const { user, hasPermission, hasAnyPermission, getUserRole } = useAuth();
  const userRole = getUserRole();

  // If still loading user data, show nothing or loading state
  if (!user && localStorage.getItem("token")) {
    return null; // Or a loading spinner
  }

  // Check role if specified
  if (role) {
    if (Array.isArray(role)) {
      if (!role.includes(userRole) && userRole !== "admin") {
        return fallback;
      }
    } else {
      if (userRole !== role && userRole !== "admin") {
        return fallback;
      }
    }
  }

  // Check single permission
  if (permission && !hasPermission(permission)) {
    return fallback;
  }

  // Check multiple permissions
  if (permissions) {
    if (requireAll) {
      // User must have ALL permissions
      const hasAllPermissions = permissions.every((perm) =>
        hasPermission(perm)
      );
      if (!hasAllPermissions) {
        return fallback;
      }
    } else {
      // User must have ANY permission (default behavior)
      if (!hasAnyPermission(permissions)) {
        return fallback;
      }
    }
  }

  return children;
};

export default PermissionGuard;
